import { render, staticRenderFns } from "./whois.vue?vue&type=template&id=2c772562&"
import script from "./whois.vue?vue&type=script&lang=js&"
export * from "./whois.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports